import batch_settings_mixin from './_mixin';

/**
 * 送料無料設定モーダル
 */
export default {
    name: 'modalBatchSettingsWeight',
    template: '#modal_batch_settings_weight_template',
    mixins: [ batch_settings_mixin ],
};
